import axios from 'axios';
import { APIEndpoints } from '../config/APIEndpoints';

export interface LiveKitTokenResponse {
  token: string;
  room: string;
  identity: string;
  bot_active: boolean;
}

export class LiveKitTokenService {
  /**
   * Get a LiveKit token for a user
   * @param identity User identity (unique identifier)
   * @param room Room name (optional - if not provided, generates a unique room name)
   * @returns LiveKit token response with token and room name
   */
  static async getToken(identity: string, room?: string): Promise<LiveKitTokenResponse> {
    try {
      // Generate unique room name if not provided
      const uniqueRoom = room || `room-${identity}-${Date.now()}`;
      
      const response = await axios.get<LiveKitTokenResponse>(
        `${APIEndpoints.LIVEKIT.TOKEN}?identity=${encodeURIComponent(identity)}&room=${encodeURIComponent(uniqueRoom)}`
      );
      return response.data;
    } catch (error) {
      console.error('Failed to get LiveKit token:', error);
      if (axios.isAxiosError(error) && !error.response) {
        throw new Error('Failed to connect to backend server. Is it running on port 8000?');
      }
      throw new Error(`Failed to get LiveKit token: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }
}
